export const emptyFilter = {
  id: '',
  appId: '',
  appName: '',
  publisherId: '',
  publisherName: '',
  publisherEmail: '',
  publisherWebsite: '',
  apiStatus: 'pending',
  adType: '',
  requestedAt: {
    from: '',
    to: '',
  },
};

export const initial = {
  currentPage: 1,
  itemsPerPage: 10,
  items: [],
  sort: {
    key: 'requestedAt',
    order: -1,
  },
  filter: emptyFilter,
  countOfAll: 0,
  isThereNewApiStatus: false,
};



/** WEBPACK FOOTER **
 ** ./js/redux/state/apiStatuses.state.js
 **/